import { enUS } from 'date-fns/locale';

import Logger from '../../shared/logger';

import { DateServiceConfig } from './types';

export const DEFAULT_CONFIG: DateServiceConfig = {
  defaultTimezone: 'America/Chicago', // Central Time for insurance operations
  locale: enUS,
  fiscalYearStart: { month: 1, day: 1 },
  businessDaysOnly: false,
  holidays: [],
  debug: process.env.NODE_ENV === 'development',
  logger: Logger
};

export const US_FEDERAL_HOLIDAYS_2024 = [
  new Date(2024, 0, 1), // New Year's Day
  new Date(2024, 0, 15), // Martin Luther King Jr. Day
  new Date(2024, 1, 19), // Presidents' Day
  new Date(2024, 4, 27), // Memorial Day
  new Date(2024, 6, 4), // Independence Day
  new Date(2024, 8, 2), // Labor Day
  new Date(2024, 9, 14), // Columbus Day
  new Date(2024, 10, 11), // Veterans Day
  new Date(2024, 10, 28), // Thanksgiving
  new Date(2024, 11, 25) // Christmas
];

export const DATE_FORMATS = {
  API_DATE: 'yyyy-MM-dd',
  API_DATETIME: "yyyy-MM-dd'T'HH:mm:ss",
  US_DISPLAY: 'MM/dd/yyyy',
  EU_DISPLAY: 'dd/MM/yyyy',
  LONG_DISPLAY: 'MMM dd, yyyy',
  ISO_8601: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
} as const;
